// extracted by mini-css-extract-plugin
export default {"contents":"AboutUsPage_contents__lG6QI","bioWrapper":"AboutUsPage_bioWrapper__GcK5E","bioImage":"AboutUsPage_bioImage__qSPhH"};